
declare module '@mui/material/styles' {
  interface BreakpointOverrides {
    xxl: true;
  }
}

export const componentOverrides = (theme: any) => ({
  MuiSlider: {
    styleOverrides: {
      thumb: {
        color: theme.palette.primary.main,
      },
    },
  },
  MuiIconButton: {
    styleOverrides: {
      root: {
        color: theme.palette.secondary.main,
        transition: 'transform 0.3s ease, color 0.3s ease',
        '&:hover': {
          backgroundColor: 'transparent',
          color: theme.palette.action.hover,
          transform: 'scale(1.2)',
        },
      },
    },
  },
  MuiTooltip: {
    styleOverrides: {
      tooltip: {
        borderRadius: '4px',
        backgroundColor: theme.palette.primary.main,
        color:
          theme.palette.mode === 'dark'
            ? theme.palette.text.primary
            : theme.palette.text.secondary,
      },
    },
  },
  MuiButton: {
    styleOverrides: {
      root: {
        borderColor: theme.palette.primary.main,
        minWidth: 'auto',
        padding: '6px 12px',
        '&:hover': {
          backgroundColor: `${theme.palette.primary.main}20`,
        },
      },
      sizeSmall: {
        padding: '4px 8px',
        fontSize: '0.875rem',
      },
    },
  },
  MuiAppBar: {
    styleOverrides: {
      root: {
        backgroundColor: theme.palette.background.paper,
        color: theme.palette.text.primary,
      },
    },
  },
  MuiToolbar: {
    styleOverrides: {
      root: {
        backgroundColor: theme.palette.background.paper,
        color: theme.palette.text.primary,
      },
    },
  },
  MuiCircularProgress: {
    styleOverrides: {
      root: {
        color: theme.palette.primary.main,
      },
    },
  },
  MuiListItem: {
    styleOverrides: {
      root: {
        backgroundColor: 'transparent',
        color: theme.palette.text.primary,
      },
    },
  },
});

export const createCustomTheme = (mode: 'light' | 'dark') => {
  return {
    breakpoints: {
      values: {
        xs: 0,
        sm: 600,
        md: 900,
        lg: 1200,
        xl: 1536,
        xxl: 1920, 
      },
    },
  };
};